import { createFileRoute } from "@tanstack/react-router";

import { RelationshipModelPage } from "@/components/portal/apps/reporting/model";

export const Route = createFileRoute("/portal/apps/reporting/model/")({
  component: RelationshipModelPage,
});
